import type { ReactNode } from 'react'
import { MAJOR_ARCANA, ZODIAC_SIGNS } from '@lunary/tarot-data'
import type { AdminUserResponseDto } from '@lunary/api-client'
import { LunarAmount } from '@lunary/ui-web/lunar-text'
import { formatDateTime, relativeSeen, roleLabel, sourceLabel } from './labels'
import styles from './user-card.module.css'

function arcanaName(id: number | null): string {
  if (id === null) return 'не указан'
  const card = MAJOR_ARCANA.find((c) => c.number === id)
  return card ? `${id} · ${card.name}` : String(id)
}

function zodiacLabel(id: string | null): string {
  return ZODIAC_SIGNS.find((s) => s.id === id)?.name ?? 'не указан'
}

export function UserProfile({ user, activeSessions }: { user: AdminUserResponseDto; activeSessions: number | null }) {
  const rows: [string, ReactNode][] = [
    ['Роль', roleLabel(user.role)],
    ['Email', user.email ?? 'нет'],
    ['Telegram', user.telegram_linked ? 'привязан' : 'нет'],
    ['Пришёл из', sourceLabel(user.signup_source)],
    ['Зарегистрирован', formatDateTime(user.created_at)],
    ['Последняя активность', `${relativeSeen(user.last_seen_at)}, ${sourceLabel(user.last_seen_source)}`],
    ['Активных сессий', activeSessions === null ? '…' : String(activeSessions)],
    ['Личный аркан', arcanaName(user.arcana_id)],
    ['Знак зодиака', zodiacLabel(user.zodiac)],
    ['Тариф', user.plan],
    ['Лунары', <LunarAmount n={user.lunars_balance} size={16} word={false} />],
  ]
  return (
    <section className="card-panel" aria-labelledby="user-profile-title">
      <h2 id="user-profile-title">Профиль</h2>
      {user.blocked_at && (
        <p className={styles.blocked} role="status">
          Заблокирован {formatDateTime(user.blocked_at)}
          {user.blocked_reason ? `: ${user.blocked_reason}` : ''}
        </p>
      )}
      <dl className={styles.facts}>
        {rows.map(([label, value]) => (
          <div key={label} className={styles.fact}>
            <dt className="muted">{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>
    </section>
  )
}
